import { UserState } from '@/composition/users'
import { useGlobalStore } from '@/store/app'
import { watch } from 'vue'

export function waitForLocationId(): Promise<void> {
  const appStore = useGlobalStore()

  return new Promise(resolve => {
    if (appStore.locationId) {
      resolve()
      return
    }

    const unwatch = watch(
      () => appStore.locationId,
      locationId => {
        if (locationId) {
          unwatch()
          resolve()
        }
      },
      { immediate: true }
    )
  })
}

export function waitForStoreIds(): Promise<void> {
  const appStore = useGlobalStore()

  return new Promise(resolve => {
    if (appStore.locationId && appStore.groupId) {
      resolve()
      return
    }

    const unwatch = watch(
      () => ({
        locationId: appStore.locationId,
        groupId: appStore.groupId,
      }),
      newValues => {
        if (newValues.locationId && newValues.groupId) {
          unwatch()
          resolve()
        }
      },
      { immediate: true }
    )
  })
}

export function waitForUserId(): Promise<void> {
  const appStore = useGlobalStore()

  return new Promise(resolve => {
    if (appStore.userId) {
      resolve()
      return
    }

    const unwatch = watch(
      () => appStore.userId,
      userId => {
        if (userId) {
          unwatch()
          resolve()
        }
      },
      { immediate: true }
    )
  })
}

export function waitForCurrentUser(): Promise<void> {
  return new Promise(resolve => {
    if (UserState.state.currentUser) {
      resolve()
      return
    }

    const unwatch = watch(
      () => UserState.state.currentUser,
      currentUser => {
        if (currentUser) {
          unwatch()
          resolve()
        }
      },
      { immediate: true }
    )
  })
}
